import { navigateToUrl } from 'single-spa';
import { LogoBox } from './Header.styles';
import { Logo } from '../Logo';

export function HeaderLogo({ title, link, src }: { title?: string; link: string; src?: string }) {
  return (
    <LogoBox href={link} onClick={navigateToUrl}>
      {src && <Logo src={src} />}
      {title && <span className="header-logo-title">{title}</span>}
    </LogoBox>
  );
}
